import { Modal } from 'bootstrap';
const initApplicationForm = () => {
  if(document.querySelectorAll('.safr-application-form form').length > 0) {
    const modalElement = document.querySelector('#applicationFormFeedbackModal');
    if(!modalElement) return;
    const formFeedbackModal = new Modal(modalElement, {});
    document.addEventListener('wpcf7submit', function(event) {
      // Check if the submitted form is a contact form
      const submittedForm = event.target;
      if (!submittedForm.closest('.safr-application-form')) {
        return; // Exit if not a contact form
      }

      const { status, message } = event.detail.apiResponse;
      const feedbackContent = document.querySelector('#applicationFormFeedbackContent');
      console.log(status === 'validation_failed' ? "Oops" : "Success", message);
      feedbackContent.innerHTML = `<div class="${status === 'validation_failed' ? 'text-danger' : 'text-success'}">${message}</div>`;
      formFeedbackModal.show();
    }, false);
  }
}
export default initApplicationForm;